module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("    ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [_c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼" + _vm._s(item.fixed_link_code) + "  道路限速" + _vm._s(item.road_speed_limit) + " 舉發車速(超速)" + _vm._s(item.break_value) + " 舉發車速(龜速)" + _vm._s(item.break_value_slow))])])])
  })], 2), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/interval-speed-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "row-class": _vm.onRowClass,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "check-detail"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s((props.rowIndex + 1) + (_vm.currentPage - 1) * 20))])]
      }
    }])
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無違規資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號或開單狀態"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("警示車速(km/hr)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alarmSpeed),
      expression: "alarmSpeed"
    }],
    staticClass: "form-control form-control-sm text-danger",
    attrs: {
      "type": "number",
      "placeholder": "輸入警示車速"
    },
    domProps: {
      "value": (_vm.alarmSpeed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alarmSpeed = $event.target.value
      }
    }
  }), _c('label', [_vm._v("警示違規筆數")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alarmIllegalNum),
      expression: "alarmIllegalNum"
    }],
    staticClass: "form-control form-control-sm text-danger",
    attrs: {
      "type": "number",
      "placeholder": "輸入警示違規筆數"
    },
    domProps: {
      "value": (_vm.alarmIllegalNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alarmIllegalNum = $event.target.value
      }
    }
  }), _c('h3', {
    staticClass: "text-danger",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("違規件數:" + _vm._s(_vm.totalIllegalNum))])]), (_vm.totalIllegalNum > _vm.alarmIllegalNum) ? _c('div', [_c('h4', {
    staticClass: "text-danger"
  }, [_vm._v("違規筆數異常，請注意!!     ")])]) : _vm._e()]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("區間測速資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ad0378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/CarList.vue
// module id = 1371
// module chunks = 1